import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import FeedbackForm from './components/FeedbackForm';
import FeedbackThankYou from './components/FeedbackThankYou';

function App() {
  return (
    <Router>
      <div className="App">
      <header className="App-header">
        <div className="header-content">
          <h1 className="header-logo">V</h1>
          <div id="vf-header-slot" className="header-drink-name"></div>
        </div>
      </header>

        <main className="App-main">
          <Routes>
            <Route path="/feedback/:batchNumber" element={<FeedbackForm />} />
            <Route path="/feedback/thankyou/:batchNumber" element={<FeedbackThankYou />} />
            <Route path="/" element={<div style={{padding: '2rem', textAlign: 'center'}}>
              <h2>Welcome to Verdant Feedback</h2>
              <p>Please use the link provided to access your feedback form.</p>
            </div>} />
          </Routes>
        </main>

        <footer className="App-footer">
          <p>&copy; 2026 Verdant.</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
